import { gql } from "@/gql";

export const CUSTOMER_ROUTE_IDS = gql(`
  query CustomerRouteIds($accountId: ID!) {
    dealerCustomers(accountId: $accountId) {
      id
      iamId
    }
  }
`);
